import styles from "../styles/pages/main.module.css";
import Nav from "../components/Nav";
import ChannelList from "../components/ChannelList";
import GlobalData from "../components/GlobalData";
import config from "../config";
import Modal from "../components/Modal";
import { useEffect, useState } from "react";
import { appStore } from "../stores";
import { observer } from "mobx-react-lite";
import { useLocation } from "react-router-dom";


function Channels() {
  const tg = window.Telegram.WebApp;
  const [openAddChannelWarning, setOpenAddChannelWarning] = useState<string | null>(null);
  const [openedAddChannel, setOpenedAddChannel] = useState(0);
  const location = useLocation();

  const closeModal = () => {
    const chatType = openAddChannelWarning as string;
    setOpenAddChannelWarning(null);
    localStorage.setItem("AddChannelWarning", "true");
    addChat(chatType);
  };

  useEffect(() => {
    appStore.getChats();
  }, [location.key]);

  useEffect(() => {
    if (openedAddChannel === 1) {
      const intervalId = setInterval(async () => {
        const prevLengthChats = appStore.chats.length;
        await appStore.getChats();
        if (prevLengthChats !== appStore.chats.length) {
          setOpenedAddChannel(prev => {
            const newValue = prev - (appStore.chats.length - prevLengthChats);
            
            if (newValue <= 0) {
              clearInterval(intervalId);
              return 0;
            };

            return newValue;
          });
        };
      }, 1000);

      return () => clearInterval(intervalId);
    };
  }, [openedAddChannel]);

  const addChat = (type: string) => {
    tg.HapticFeedback.impactOccurred("light");

    if (localStorage.getItem("AddChannelWarning") !== "true") {
      setOpenAddChannelWarning(type);
      return;
    };

    setOpenedAddChannel(prev => prev + 1);

    if (type === 'channel') {
      tg.openTelegramLink(`https://t.me/${config.botUsername}?startchannel&admin=invite_users`);
    } else if (type === 'group') {
      tg.openTelegramLink(`https://t.me/${config.botUsername}?startgroup&admin=invite_users`);
    };
  };

  return (
    <>
      <div className={styles.body}>
          {openAddChannelWarning !== null && <Modal cancel={closeModal}>
            <h1>Добавление канала</h1>
            <span>После нажатия на кнопку “Добавить”, выберите свой канал или группу. Телеграм предложит добавить бота в администраторы, это безопасно, у бота будут права только для добавления подписчиков. Не изменяйте их.</span>
            <button type="submit" onClick={closeModal}>Понятно</button>
          </Modal>}
          <GlobalData/>
          <ChannelList 
            bottomButtons={{"Добавить канал": () => addChat('channel'), "Добавить группу": () => addChat('group')}}
            handleChannelButton={null}
            handleChannelClick={null}
            mode="chats"
            list={appStore.chats}
            nullMessage="Для того чтобы привлечь подписчиков в свой канал, добавьте его" 
            scrollBottomCallback={null}
            inline={false}
            loadingDescription={appStore.chatsUpdateProcess}
          />
          <Nav activePage={3}/>
      </div>
    </>
  );
}

export default observer(Channels);